<section class="page-loading" [ngClass]="variant">
  <div class="page-loading__orb page-loading__orb--a"></div>
  <div class="page-loading__orb page-loading__orb--b"></div>

  <div class="page-loading__panel">
    <div class="page-loading__copy">
      <span class="page-loading__eyebrow">{{ eyebrow }}</span>
      <h2>{{ title }}</h2>
      <p>{{ message }}</p>
    </div>

    <div class="page-loading__preview" aria-hidden="true">
      <div class="preview-card preview-card--hero">
        <span class="skeleton skeleton--badge"></span>
        <span class="skeleton skeleton--title"></span>
        <span class="skeleton skeleton--text"></span>
        <span class="skeleton skeleton--text skeleton--text-short"></span>
      </div>

      <div class="preview-grid">
        <div class="preview-card" *ngFor="let item of [1, 2, 3]">
          <span class="skeleton skeleton--line"></span>
          <span class="skeleton skeleton--line"></span>
          <span class="skeleton skeleton--line skeleton--line-short"></span>
        </div>
      </div>
    </div>
  </div>
</section>
